<div class="dialog-content-wrapper">

  <div mat-dialog-title>
    <h2>
      {{'generic.chapters_filter_title' | translate}}
    </h2>
    <button class="close"
      (click)="dialogRef.close()"
      aria-label="Close dialog">
      <mat-icon svgIcon="cross"></mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-24 m-0" >
    <form  novalidate >
      <div  class="mb-24"
        fxLayout="row"
        fxLayoutAlign="start start">
        <mat-form-field class="w-100-p">
          <mat-label>{{ 'generic.method' | translate }}</mat-label><mat-select  [(value)]="selectedMethod"

          (selectionChange)="selectMethod($event, true)">
          <mat-option value="all">{{ 'generic.all' | translate }}</mat-option>
          @for (option of methods; track option) {
            <mat-option [value]="option.id">
              {{ option?.get('name') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="mb-24 fontBold">{{ 'generic.select_chapter_help' | translate}}</div>
    <div class="mb-24 fontBold">{{chaptersSelected.length}}
      @if (chaptersSelected.length < 2) {
        <span>{{ 'generic.selected_chapter' | translate}}</span>
      }
      @if (chaptersSelected.length > 1) {
        <span>{{ 'generic.selected_chapters' | translate}}</span>
      }
      @if (chaptersSelected.length > 0) {
        <button  mat-icon-button (click)="resetChapters(true)">
          <mat-icon svgIcon="cross"></mat-icon>
        </button>
      }
    </div>

    <div class="mb-24 h-400" fusePerfectScrollbar>

      @if (dataSource?.data?.length) {
        <div>
          <mat-checkbox (change)="updateCheck($event)" [(ngModel)]="selectAll" [ngModelOptions]="{standalone: true}">
            {{ 'generic.select_all_chapters' | translate }}
          </mat-checkbox>
        </div>
      }

      <table mat-table #table [dataSource]="dataSource"
        [@animateStagger]="{value:'50'}">
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef><span class="th__span--hidden-accessibility">{{'accessibility.th_hidden_label' | translate}}</span></th>
          <td mat-cell *matCellDef="let entity">
            <p [ngClass]="{'custom' : isChildren(entity)}" class="text-truncate">{{entity.label}}</p>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let entity; columns: displayedColumns;"
          class="entity"
          (click)="selectedChapter(entity)"
          matRipple
          [ngClass]="{'selected': checkSelected(entity) > -1}"
          [@animate]="{value:'*',params:{y:'100%'}}">
        </tr>
      </table>
    </div>

  </form>
</div>

@if (isLoading) {
  <div class="example-loading-shade"
    >
    <mat-spinner></mat-spinner>
  </div>
}

<div mat-dialog-actions>
  <button mat-raised-button
    (click)="dialogRef.close(chaptersSelected)"
    [disabled]="isLoading"
    class="save-button mat-accent"
    aria-label="SAVE">
    {{ 'generic.validate' | translate }}
  </button>

</div>
</div>